import React from 'react'
// import styled from '@emotion/styled'
import { Popover } from '@mantine/core'
// import clsx from 'clsx'
import { pick } from 'lodash-es'
// import { UseTheme } from '@ow/comps'
import { useListStore } from '@ow/ditto-core'

// const OptItem = styled.div`
//   color: var(--ow-color-gray-100);
//   &:hover {
//     background: var(--ow-color-primary-50);
//     color: var(--ow-color-primary-700);
//   }
// `

// const maps = {
//   logConfig: '查看日志',
//   detailConfig: '查看详情',
//   editorConfig: '编辑',
//   recoveryConfig: '恢复',
//   deleteConfig: '删除',
// }

const Operate = ({ operators }) => {
  // const { themeClass } = UseTheme()
  const { OperateComponent = {} } = useListStore((state) =>
    pick(state, ['OperateComponent'])
  )
  const { payload } = operators || {}

  // // 传进来
  // const headerOpts = {
  //   // 普通显示
  //   common: [
  //     {
  //       type: 'edit',
  //       title: '编辑',
  //       onClick: () => {
  //         hooks.onCloumnOperate('edit', payload)
  //       },
  //     },
  //     {
  //       type: 'log',
  //       title: '查看日志',
  //       onClick: () => {
  //         hooks.onCloumnOperate('log', payload)
  //       },
  //     },
  //   ],
  // }

  // const operatorsAllowed = useMemo(() => {
  //   const currentOperatorConfig = showRecycle
  //     ? operatorConfig.recycle
  //     : operatorConfig.operatorConfig

  //   return currentOperatorConfig && currentOperatorConfig.elements
  // }, [])

  return (
    <Popover
      width={100}
      position="bottom"
      withinPortal
      styles={{
        dropdown: {
          background: '#FFFFFF',
          border: '0.5px solid #DCDCDC',
          boxShadow:
            '0 5px 5px -3px rgba(0,0,0,0.10), 0 8px 10px 1px rgba(0,0,0,0.06), 0 3px 14px 2px rgba(0,0,0,0.05)',
          borderRadius: '4px',
          padding: '0',
        },
      }}
    >
      <Popover.Target>
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="icon icon-tabler icon-tabler-dots"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            fill="var(--ow-color-gray-100)"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <circle cx="5" cy="12" r="1" />
            <circle cx="12" cy="12" r="1" />
            <circle cx="19" cy="12" r="1" />
          </svg>
        </div>
      </Popover.Target>
      <Popover.Dropdown>
        <OperateComponent payload={payload} />
        {/* <div className={clsx(themeClass, 'p-2')} style={{ fontSize: '14px' }}>
          {operatorsAllowed.common.map((item) => {
            return (
              <OptItem
                key={item.actionType}
                onClick={() => {
                  hooks.onCloumnOperate(item.actionType, payload)
                }}
                className="p-2 cursor-pointer"
              >
                {maps[item.actionType]}
              </OptItem>
            )
          })}
        </div> */}
      </Popover.Dropdown>
    </Popover>
  )
}
export default Operate
